<div *ngIf="isLoaded">
    <div class="loading">
        <div class="loader"></div>

      </div>
</div>



<!-- <app-cookie-banner></app-cookie-banner> -->

<router-outlet></router-outlet>
